module.exports = __webpack_public_path__ + "media/images/1920/annie-spratt-7MX4Clmx-K0-unsplash-fb598e74a1b387f60a3fc1161588e444.jpg";